'use client';

import { c as _c } from "react/compiler-runtime";
import { PopoverAnchor } from '@radix-ui/react-popover';
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList, Input, Popover, PopoverContent, Skeleton } from '@repo/ui/components';
import { cn } from '@repo/ui/lib';
import { Command as CommandPrimitive } from 'cmdk';
import { Check } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useAutoComplete } from './use-auto-complete.ts'; // Adjust the path accordingly

export function AutoComplete(t0) {
  const $ = _c(63);
  const {
    className,
    data,
    emptyMessage: t1,
    getDisplayValue,
    getSearchValue,
    isLoading,
    onSearchValueChange,
    onSelectedValueChange,
    placeholder: t2,
    renderOption,
    searchStartLength: t3,
    searchValue,
    selectedValue
  } = t0;
  const emptyMessage = t1 === undefined ? "No items." : t1;
  const placeholder = t2 === undefined ? "Search..." : t2;
  const searchStartLength = t3 === undefined ? 0 : t3;
  let t4;
  if ($[0] !== data || $[1] !== getDisplayValue || $[2] !== getSearchValue || $[3] !== onSearchValueChange || $[4] !== onSelectedValueChange || $[5] !== searchValue || $[6] !== selectedValue) {
    t4 = {
      data,
      getDisplayValue,
      getSearchValue,
      onSearchValueChange,
      onSelectedValueChange,
      searchValue,
      selectedValue
    };
    $[0] = data;
    $[1] = getDisplayValue;
    $[2] = getSearchValue;
    $[3] = onSearchValueChange;
    $[4] = onSelectedValueChange;
    $[5] = searchValue;
    $[6] = selectedValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    displayValue,
    onInputBlur,
    onSelectItem,
    open,
    setOpen
  } = useAutoComplete(t4);
  const [searchTerm, setSearchTerm] = useState(displayValue);
  let t5;
  if ($[8] !== displayValue || $[9] !== selectedValue) {
    t5 = () => {
      if (selectedValue) {
        setSearchTerm(displayValue);
      }
    };
    $[8] = displayValue;
    $[9] = selectedValue;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== selectedValue) {
    t6 = [selectedValue];
    $[11] = selectedValue;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== onSearchValueChange || $[14] !== searchTerm) {
    t7 = () => {
      const timeout = setTimeout(() => {
        onSearchValueChange(searchTerm);
      }, 500);
      return () => clearTimeout(timeout);
    };
    $[13] = onSearchValueChange;
    $[14] = searchTerm;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== searchTerm) {
    t8 = [searchTerm];
    $[16] = searchTerm;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  useEffect(t7, t8);
  let t9;
  if ($[18] !== className) {
    t9 = cn("flex items-center", className);
    $[18] = className;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== searchValue || $[21] !== setOpen) {
    t10 = () => setOpen(() => !!searchValue);
    $[20] = searchValue;
    $[21] = setOpen;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== searchStartLength || $[24] !== searchValue.length || $[25] !== setOpen) {
    t11 = search => {
      if (searchValue.length >= searchStartLength - 1) {
        setOpen(true);
      } else {
        setOpen(false);
      }
      setSearchTerm(search);
    };
    $[23] = searchStartLength;
    $[24] = searchValue.length;
    $[25] = setOpen;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== placeholder) {
    t12 = <Input placeholder={placeholder} />;
    $[27] = placeholder;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== onInputBlur || $[30] !== searchTerm || $[31] !== t10 || $[32] !== t11 || $[33] !== t12) {
    t13 = <PopoverAnchor asChild={true}><CommandPrimitive.Input asChild={true} onBlur={onInputBlur} onMouseDown={t10} onValueChange={t11} value={searchTerm}>{t12}</CommandPrimitive.Input></PopoverAnchor>;
    $[29] = onInputBlur;
    $[30] = searchTerm;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      width: "var(--radix-popover-trigger-width)"
    };
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== isLoading) {
    t15 = isLoading && <CommandPrimitive.Loading><div className="p-1"><Skeleton className="h-12 w-full" /></div></CommandPrimitive.Loading>;
    $[36] = isLoading;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== data || $[39] !== getSearchValue || $[40] !== isLoading || $[41] !== onSelectItem || $[42] !== renderOption || $[43] !== selectedValue) {
    t16 = !isLoading && data.length > 0 && <CommandGroup>{data.map(item => {
        const key = getSearchValue(item);
        const isSelected = selectedValue && getSearchValue(selectedValue) === key;
        return <CommandItem key={key} onMouseDown={_temp3} onSelect={() => onSelectItem(key)} value={key}><Check className={cn("mr-2 h-4 w-4", isSelected ? "opacity-100" : "opacity-0")} />{renderOption(item)}</CommandItem>;
      })}</CommandGroup>;
    $[38] = data;
    $[39] = getSearchValue;
    $[40] = isLoading;
    $[41] = onSelectItem;
    $[42] = renderOption;
    $[43] = selectedValue;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== data || $[46] !== emptyMessage || $[47] !== isLoading) {
    t17 = !isLoading && data.length === 0 && <CommandEmpty>{emptyMessage}</CommandEmpty>;
    $[45] = data;
    $[46] = emptyMessage;
    $[47] = isLoading;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t15 || $[50] !== t16 || $[51] !== t17) {
    t18 = <PopoverContent asChild={true} className="p-0" onInteractOutside={_temp} onOpenAutoFocus={_temp2} style={t14}><CommandList>{t15}{t16}{t17}</CommandList></PopoverContent>;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== t13 || $[54] !== t18) {
    t19 = <Command shouldFilter={false}>{t13}{t18}</Command>;
    $[53] = t13;
    $[54] = t18;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  let t20;
  if ($[56] !== open || $[57] !== setOpen || $[58] !== t19) {
    t20 = <Popover onOpenChange={setOpen} open={open}>{t19}</Popover>;
    $[56] = open;
    $[57] = setOpen;
    $[58] = t19;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t20 || $[61] !== t9) {
    t21 = <div className={t9}>{t20}</div>;
    $[60] = t20;
    $[61] = t9;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  return t21;
}
function _temp3(e_1) {
  return e_1.preventDefault();
}
function _temp2(e_0) {
  return e_0.preventDefault();
}
function _temp(e) {
  if (e.target instanceof Element && e.target.hasAttribute("cmdk-input")) {
    e.preventDefault();
  }
}